import { createSlice } from "@reduxjs/toolkit";
import BookMarkAPIS from "api/Bookmark/bookmark"
// import { requests } from 'api/index';
// import URLS  from 'api/endPoints';

const initialCoursestate = {
    ALLBOOKMARKS:"",ADDBOOKMARK:"",
}

const slice = createSlice({
    name: "Bookmark",
    initialState: {
        Bookmark: initialCoursestate,
    },
    reducers: {
        getAllBookmarks: (state, action) => {
    
            state.course.ALLBOOKMARKS = action.payload
          },
          addBookmark :(state, action)=>{

              state.course.ADDBOOKMARK = action.payload

          }
    }

})
export default slice.reducer;

const {getAllBookmarks,addBookmark} = slice.actions
export const GetAllBookMarkAction = (payload) => async dispatch => {
    try {
      
      let response = await BookMarkAPIS.GetAllBookmarks(payload)
      
      await dispatch(getAllBookmarks(response))
      return await returnCode(response)
    } catch (error) {
       return console.error(error.message)
    }
  }

  export const AddBookmarkACTION = (payload) => async dispatch => {
    try {
      let response = await BookMarkAPIS.AddBookmark(payload)
      await dispatch(addBookmark(response))
      return await returnCode(response)
    } catch (error) {
       return console.error(error.message)
    }
  }

  function returnCode(response) {
    if (response.ResponseCode == 100 || 200) {
      return response;
    } else if (response.ResponseCode == 103) {
      return 103;
    } else {
      return 101;
    }
  }